import update from 'immutability-helper';

/**
 * Schema string types for all objects, in order of least to most detailed.
 */
export const schemaTypes = ['stub', 'abridged', 'full'];

/**
 * Compare two detail objects and return whether the first is more relevant than the second.
 */
export const moreRelevantSchema = (a = {}, b = {}) =>
  schemaTypes.indexOf(a.schemaType) >= schemaTypes.indexOf(b.schemaType);

/**
 * This function produces a reducer to maintain objects of dynamic type, stored by ID.
 */
const byId = (OBJECT = undefined, OBJECTS = undefined) => {
  if (OBJECT === undefined || OBJECTS === undefined) {
    throw new Error('Cannot create reducer, missing arguments');
  }
  /**
   * This reducer maintains data as a single object,
   * with each data object accessible by ID as a key.
   */
  return (state = {}, { meta, payload, type }) => {
    switch (type) {
      case `FETCH_${OBJECT}_FULFILLED`:
        // Only store incoming events that are more detailed than in existing state
        if (moreRelevantSchema(payload, state[meta.id])) {
          return {
            ...state,
            [meta.id]: payload,
          };
        }
        return state;
      case `FETCH_${OBJECTS}_FULFILLED`:
        // Add all the fetched objects to the state, overwriting an existing object with fresh data
        return (payload.results || []).reduce((prevState, obj) => ({
          ...prevState,
          // Only store incoming events that are more detailed than in existing state
          ...moreRelevantSchema(obj, state[obj.id]) && {
            [obj.id]: obj,
          },
        }), state);
      case `UPDATE_${OBJECT}`:
        if (!state[meta.id]) {
          return state;
        }
        return {
          ...state,
          [meta.id]: update(state[meta.id], { $merge: payload }),
        };
      default:
        return state;
    }
  };
};

export default byId;

/**
 * Selectors
 */
export const getById = (state, id) => state[id];



// WEBPACK FOOTER //
// ./app/src/state/reducers/byId.js